<template>
    <div class="basket__list">
        <BasketItem v-for="product in props.items" :product="product"
                    :key="`${product.variantId}_${product.itemId ?? ''}_${product.vibeId ?? ''}`"
                    @delete="$emit('delete', product.variantId, product.itemId, product.vibeId)"/>
    </div>
</template>

<script setup lang="ts">
import type {BasketItemInterface} from "~/interfaces/BasketItemInterface";
import type {PropType} from 'vue'
import BasketItem from "~/components/Section/Basket/BasketItem.vue";


const props = defineProps({
    items: {
        type: Array as PropType<BasketItemInterface[]>,
        required: true,
    }
});
defineEmits(['delete']);
</script>